import { IDesk, ToolType } from "../../types/Floorplan.types";
import { createDeskSvg } from "./SvgElements";

export interface IDesksProps {
    desks?: IDesk[];
    selectedDeskIdx?: number;
    selectedTool?: ToolType;
}

const Desks = (props: IDesksProps) => {
    const { desks, selectedDeskIdx, selectedTool } = props;
    if (desks && desks.length > 0) {
        return (
            <g id="desks">
                { desks.map((desk, idx) => {
                    const svg = createDeskSvg();
                    const html = svg.innerHTML;
                    let cursor: string | undefined = undefined, transform: string | undefined = undefined;
                    let className = "desk desk-" + idx;
                    if (selectedTool === "Pointer" && selectedDeskIdx === idx) {
                        className = "draggable draggableDesk-" + idx;
                    }
                    if (desk.rotation !== 0) {
                        transform = `rotate(${desk.rotation})`;
                    }
                    if (!desk.bookable) className += " nonAvailableDesk";
                    
                    return (
                        <svg key={`desk_${idx}`} data-idx={idx} className={className} pointerEvents="all" style={{cursor}} x={desk.x} y={desk.y} overflow="visible">
                            <g transform={transform} style={{transformOrigin: "10px 12px"}} dangerouslySetInnerHTML={{__html: html}}></g>
                        </svg>
                    );
                }) }
            </g>
        );
    }
    return null;
};

export default Desks;